














import { ICrumb } from "@/components/app-base/UBreadcrumbs.vue";
import { IUser } from "@/models/users";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    "credit-notes-table": () =>
      import("@/components/app/global/creditNotes/creditNotesTable.vue")
  }
})
export default class AdminUpmindCreditNotes extends Vue {
  @Prop({ required: true })
  public user!: IUser;

  // Data
  public breadcrumbs: ICrumb[] = [
    {
      label: this.$t("_.my_upmind"),
      route: {
        to: {
          name: "admin__upmindAccount"
        }
      }
    },
    {
      label: this.$t("_.billing")
    }
  ];
  public tableProps = {
    id: "UPMCN",
    dataScope: `$client_${this.user?.upmind_client_id}_credit_notes`
  };
}
